import SellersService from "@/api/services/sellers";
import { toCamelCase } from "@/utils/utils";

const initialState = {
  index: [],
  totalPages: null,
  totalCount: null,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, data) {
      state.index = data.sellers;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async delete(_, id) {
      return await SellersService.delete(id);
    },

    async update(_, { id, data }) {
      return await SellersService.update(id, data);
    },

    async fetchIndex({ commit }, { storeId, keywords, page = 1, includes, trainingModuleId }) {
      const response = await SellersService.fetchIndex({ storeId, keywords, page, includes, trainingModuleId });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);

      return response;
    },
    async create(_, { storeId, data }) {
      return await SellersService.create({ storeId, ...data });
    },
  },
};
